export default __webpack_public_path__ + "static/illustration-business.url-8b0d6b64037f6df7fa25443c6eafeb12.svg";